var path = 'areas/shared/views/sensitive-input.html';
var html = "<div class=input-sensitive> <div class=input-group ng-if=!isEditingPassword> <input class=form-control type=password placeholder=\"{{ hasPassword ? '******' : '' }}\" disabled=disabled> <div class=input-group-btn> <a type=button class=\"btn btn-primary\" ng-click=set()>{{ setOrChange }}</a> <a type=button class=\"btn btn-primary\" ng-click=clear() ng-show=hasPassword>Remove</a> </div> </div> <div class=input-group ng-if=isEditingPassword> <input class=form-control type=password ng-model=model.NewValue ng-focus=isEditingPassword> <div class=input-group-btn> <a type=button class=\"btn btn-primary\" ng-click=undo()>Cancel</a> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/sensitive-input.html
// module id = 978
// module chunks = 1